import React, { useEffect, useState } from "react";
import { motion, useMotionValue, useTransform, animate } from "framer-motion";
import { Eye } from "lucide-react";
import { api } from "../lib/api";

const SESSION_KEY = "gabs_visit_tracked";

export default function VisitCounter() {
    const [count, setCount] = useState(0);
    const [ready, setReady] = useState(false);
    const mv = useMotionValue(0);
    const rounded = useTransform(mv, (v) =>
        Math.round(v).toLocaleString("fr-FR")
    );

    useEffect(() => {
        let cancelled = false;
        const alreadyTracked = (() => {
            try {
                return sessionStorage.getItem(SESSION_KEY) === "1";
            } catch {
                return false;
            }
        })();
        const call = alreadyTracked
            ? api.get("/visits/count")
            : api.post("/visits/track").then((r) => {
                  try {
                      sessionStorage.setItem(SESSION_KEY, "1");
                  } catch {
                      /* noop */
                  }
                  return r;
              });
        call
            .then((r) => {
                if (cancelled) return;
                setCount(r.data?.count || 0);
                setReady(true);
            })
            .catch(() => setReady(true));
        return () => {
            cancelled = true;
        };
    }, []);

    useEffect(() => {
        if (!ready) return;
        const controls = animate(mv, count, {
            duration: 1.4,
            ease: [0.16, 1, 0.3, 1],
        });
        return () => controls.stop();
    }, [count, ready, mv]);

    return (
        <div
            className="hidden md:inline-flex items-center gap-2 px-3 py-1 bg-white/8 border border-white/15 text-white/90"
            data-testid="visit-counter"
            title="Visites du site"
        >
            <span className="relative flex w-2 h-2">
                <span className="absolute inline-flex h-full w-full rounded-full bg-brand-gold opacity-70 animate-ping" />
                <span className="relative inline-flex rounded-full h-2 w-2 bg-brand-gold" />
            </span>
            <Eye className="w-3.5 h-3.5 text-brand-gold" strokeWidth={1.5} />
            <span className="text-[0.7rem] tracking-[0.15em] font-semibold tabular-nums">
                <motion.span>{rounded}</motion.span>
            </span>
            <span className="text-[0.6rem] tracking-[0.22em] uppercase text-white/60 font-semibold hidden lg:inline">
                visites
            </span>
        </div>
    );
}
